// extracted by mini-css-extract-plugin
export default {"container":"NewForm_container__TFpYw","content":"NewForm_content__gMGuD"};